"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/**
 * @deprecated
 * It is recommended to use SvgIcon. FontIcon will be removed in a future release.
 */
const PropTypes = __importStar(require("prop-types"));
const clsx_1 = require("clsx");
const FontIcon = (_a) => {
    var { className, disabled, iconName, onClick, onKeyDown, onKeyPress, forwardRef, tabIndex, style } = _a, otherProps = __rest(_a, ["className", "disabled", "iconName", "onClick", "onKeyDown", "onKeyPress", "forwardRef", "tabIndex", "style"]);
    return ((0, jsx_runtime_1.jsx)("i", Object.assign({}, otherProps, { className: (0, clsx_1.clsx)(`tk-icon-${iconName}`, className), onClick: !disabled ? onClick : null, onKeyDown: !disabled ? onKeyDown : null, onKeyPress: !disabled ? onKeyPress : null, ref: forwardRef, style: Object.assign({ cursor: !disabled && onClick && 'pointer' }, style), tabIndex: tabIndex })));
};
FontIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    forwardRef: PropTypes.any,
    tabIndex: PropTypes.number,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyPress: PropTypes.func,
    style: PropTypes.object,
};
exports.default = FontIcon;
